export default {
  methods: {
    handleMenuSelect (index, indexPath) {
      console.log(index,indexPath)
        // this.$router.push({
        //   path: index.path
        // })
    }
  }
}
